import { useDispatch } from "react-redux";
// import { capitalize } from "lodash";
import moment from "moment";

import { FlagRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../shared";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const CSS_STATUS = {
  Withdrawn: "tw-text-[#999999]",
  Active: "tw-text-[#36B25F]",
  Closed: "tw-text-[#E5342E]",
};

const AddressStatusChangeActivity = ({ activity, onReadChange }) => {
  const queryParams = new URLSearchParams();
  queryParams.set("tab", "3");

  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]" Icon={FlagRegularV6}>
            Address Status Change
          </CategoryContainer>
        }
        personName={`${activity.data.leadFirstName} ${activity.data.leadLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <div className="tw-text-gray-75">
          {activity.data.leadFirstName}’s property status was updated to{" "}
          <span className={`tw-font-bold ${CSS_STATUS[activity.data.status]}`}>
            {activity.data.status === "Withdrawn" ? "Withdrawn/Off Market" : activity.data.status}
          </span>
          .
        </div>
        <DataField label="Address" data={activity.data.standardAddress} />
        {activity.data.listingId && <DataField label="MLS#" data={activity.data.listingId} />}
        <DataField
          label="System Notified of status change"
          data={moment(activity.updatedAt).format("MM/DD/YYYY")}
        />
        <ActivityBtns
          callHandlr={() => {
            if (activity.data?.personUuid) {
              dispatch(
                setCallParams({
                  leadUuids: [activity.data?.personUuid],
                  callSource: "Favorite Property Activity",
                }),
              );
            }
          }}
          containerClassName="!tw-mt-8px"
        />
      </div>
    </ActivityContainer>
  );
};

export default AddressStatusChangeActivity;

AddressStatusChangeActivity.propTypes = {
  ...activityCommonPropTypes,
};

AddressStatusChangeActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
